import 'react-loading-skeleton/dist/skeleton.css'
import React from 'react'
import PaymentForm from "./PaymentForm";

export default function App() {
    return <PaymentForm />;
}
